/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalframe_Denied_ActionInputs */

const en_portalframe_denied_action = /** @type {(inputs: Portalframe_Denied_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message your team`)
};

/** @type {(inputs: Portalframe_Denied_ActionInputs) => LocalizedString} */
const ar_portalframe_denied_action = en_portalframe_denied_action;

/** @type {(inputs: Portalframe_Denied_ActionInputs) => LocalizedString} */
const he_portalframe_denied_action = en_portalframe_denied_action;

/** @type {(inputs: Portalframe_Denied_ActionInputs) => LocalizedString} */
const ur_portalframe_denied_action = en_portalframe_denied_action;

/** @type {(inputs: Portalframe_Denied_ActionInputs) => LocalizedString} */
const es_portalframe_denied_action = en_portalframe_denied_action;

/** @type {(inputs: Portalframe_Denied_ActionInputs) => LocalizedString} */
const fr_portalframe_denied_action = en_portalframe_denied_action;

/** @type {(inputs: Portalframe_Denied_ActionInputs) => LocalizedString} */
const de_portalframe_denied_action = en_portalframe_denied_action;

/** @type {(inputs: Portalframe_Denied_ActionInputs) => LocalizedString} */
const pt_portalframe_denied_action = en_portalframe_denied_action;

/** @type {(inputs: Portalframe_Denied_ActionInputs) => LocalizedString} */
const hi_portalframe_denied_action = en_portalframe_denied_action;

/** @type {(inputs: Portalframe_Denied_ActionInputs) => LocalizedString} */
const bn_portalframe_denied_action = en_portalframe_denied_action;

/**
* | output |
* | --- |
* | "Message your team" |
*
* @param {Portalframe_Denied_ActionInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalframe_denied_action = /** @type {((inputs?: Portalframe_Denied_ActionInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalframe_Denied_ActionInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalframe_denied_action(inputs)
	if (locale === "he") return he_portalframe_denied_action(inputs)
	if (locale === "ur") return ur_portalframe_denied_action(inputs)
	if (locale === "es") return es_portalframe_denied_action(inputs)
	if (locale === "fr") return fr_portalframe_denied_action(inputs)
	if (locale === "de") return de_portalframe_denied_action(inputs)
	if (locale === "pt") return pt_portalframe_denied_action(inputs)
	if (locale === "hi") return hi_portalframe_denied_action(inputs)
	if (locale === "bn") return bn_portalframe_denied_action(inputs)
	return /** @type {LocalizedString} */ ("Message your team")
});